import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';
import { CreationAccesOrder } from './creation-acces-order.entity';
import { NotifiableByMailOrder } from './has-id.interface';

export class CreationDeniedAccesOrder extends CreationAccesOrder implements NotifiableByMailOrder {
	dateRefus!: LocalDateTime | null;;
	motifRefus!: number;

	forceMailsAsTest?: boolean;

	constructor() {
		super();
	}
}